import styled from "styled-components"
import { colors } from "../../../utils/styles"

export const PressSectionStyles = styled.section`
  background-color: #f4f4f4;
  .featured-tag {
    border-radius: 20px;
    color: white;
    background-color: #4cb9ef;
    font-size: 0.7rem;
    font-weight: 800;
  }
  .announcement-header h1 {
    font-weight: 800;
    font-size: 2.5rem;
    @media (max-width: 992px) {
      font-size: 2rem;
    }
  }
  .read-more {
    font-size: 1.3rem;
    font-weight: 700;
    position: relative;
    &:hover {
      color: ${colors.secondaryBlue2}
    }
    &::before {
      content: "";
      position: absolute;
      top: 40%;
      left: -30px;
      width: 20px;
      height: 1px;
      border: 1px solid ${colors.secondaryBlue2};
      background-color: green;
    }
  }
`
